import type { CreateSupplierInput, Supplier } from '#shared/types';

const EMPTY_SUPPLIER: CreateSupplierInput = {
  name: '',
  code: '',
  contact_name: '',
  phone_number: '',
  email: '',
  address: '',
  note: '',
  is_active: true,
};

/** The form's starting values: the saved supplier when editing, blanks when adding. */
export function initialSupplierValues(record?: Supplier): CreateSupplierInput {
  if (!record) return EMPTY_SUPPLIER;
  return {
    name: record.name,
    code: record.code,
    contact_name: record.contact_name ?? '',
    phone_number: record.phone_number ?? '',
    email: record.email ?? '',
    address: record.address ?? '',
    note: record.note ?? '',
    is_active: record.is_active,
  };
}
